import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResultsImportComponent } from './results-import/results-import.component';
import { ResultsImport3Component } from './results-import3/results-import3.component';

const routes: Routes = [
  { path: 'gepard/results-import', component: ResultsImportComponent },
  { path: 'gepard/results-import3', component: ResultsImport3Component }
];

@NgModule({
  imports: [RouterModule.forChild(routes)]
})
export class GepardRoutingModule {}
